// @generated by protoc-gen-es v2.2.3 with parameter "target=ts"
// @generated from file catpocs/v1/roles.proto (package catpocs.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv1";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv1";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file catpocs/v1/roles.proto.
 */
export const file_catpocs_v1_roles: GenFile = /*@__PURE__*/
  fileDesc("ChZjYXRwb2NzL3YxL3JvbGVzLnByb3RvEgpjYXRwb2NzLnYxIlcKBFVzZXISCgoCaWQYASABKAkSDQoFZW1haWwYAiABKAkSDAoEbmFtZRgDIAEoCRIOCgZncm91cHMYBCADKAkSFgoOaXNfc3VwZXJfYWRtaW4YBSABKAgiLwoKUGVybWlzc2lvbhIQCghyZXNvdXJjZRgBIAEoCRIPCgdhY3Rpb25zGAIgAygJIhcKFUdldEN1cnJlbnRVc2VyUmVxdWVzdCLcAQoWR2V0Q3VycmVudFVzZXJSZXNwb25zZRIeCgR1c2VyGAEgASgLMhAuY2F0cG9jcy52MS5Vc2VyEjIKEmdsb2JhbF9wZXJtaXNzaW9ucxgCIAMoCzIWLmNhdHBvY3MudjEuUGVybWlzc2lvbhIYChBpc19pbXBlcnNvbmF0aW5nGAMgASgIEicKDW9yaWdpbmFsX3VzZXIYBCABKAsyEC5jYXRwb2NzLnYxLlVzZXISKwoRaW1wZXJzb25hdGVkX3VzZXIYBSABKAsyEC5jYXRwb2NzLnYxLlVzZXIiLwoZR2V0VXNlclBlcm1pc3Npb25zUmVxdWVzdBISCgpwcm9qZWN0X2lkGAEgASgJIlcKGkdldFVzZXJQZXJtaXNzaW9uc1Jlc3BvbnNlEgwKBHJvbGUYASABKAkSKwoLcGVybWlzc2lvbnMYAiADKAsyFi5jYXRwb2NzLnYxLlBlcm1pc3Npb24iGAoWTGlzdFN1cGVyQWRtaW5zUmVxdWVzdCI7ChdMaXN0U3VwZXJBZG1pbnNSZXNwb25zZRIgCgZhZG1pbnMYASADKAsyEC5jYXRwb2NzLnYxLlVzZXIiNgoUQWRkU3VwZXJBZG1pblJlcXVlc3QSDwoHdXNlcl9pZBgBIAEoCRINCgVlbWFpbBgCIAEoCSI4ChVBZGRTdXBlckFkbWluUmVzcG9uc2USHwoFYWRtaW4YASABKAsyEC5jYXRwb2NzLnYxLlVzZXIiKgoXUmVtb3ZlU3VwZXJBZG1pblJlcXVlc3QSDwoHdXNlcl9pZBgBIAEoCSIrChhSZW1vdmVTdXBlckFkbWluUmVzcG9uc2USDwoHc3VjY2VzcxgBIAEoCDLcAwoLUm9sZVNlcnZpY2USVwoOR2V0Q3VycmVudFVzZXISIS5jYXRwb2NzLnYxLkdldEN1cnJlbnRVc2VyUmVxdWVzdBoiLmNhdHBvY3MudjEuR2V0Q3VycmVudFVzZXJSZXNwb25zZRJjChJHZXRVc2VyUGVybWlzc2lvbnMSJS5jYXRwb2NzLnYxLkdldFVzZXJQZXJtaXNzaW9uc1JlcXVlc3QaJi5jYXRwb2NzLnYxLkdldFVzZXJQZXJtaXNzaW9uc1Jlc3BvbnNlEloKD0xpc3RTdXBlckFkbWlucxIiLmNhdHBvY3MudjEuTGlzdFN1cGVyQWRtaW5zUmVxdWVzdBojLmNhdHBvY3MudjEuTGlzdFN1cGVyQWRtaW5zUmVzcG9uc2USVAoNQWRkU3VwZXJBZG1pbhIgLmNhdHBvY3MudjEuQWRkU3VwZXJBZG1pblJlcXVlc3QaIS5jYXRwb2NzLnYxLkFkZFN1cGVyQWRtaW5SZXNwb25zZRJdChBSZW1vdmVTdXBlckFkbWluEiMuY2F0cG9jcy52MS5SZW1vdmVTdXBlckFkbWluUmVxdWVzdBokLmNhdHBvY3MudjEuUmVtb3ZlU3VwZXJBZG1pblJlc3BvbnNlQkdaRWdpdGh1Yi5jb20vY2lzY28tZGNsb3VkL2NhdC1wb2NzLW9wZXJhdG9yL2dlbi9nby9jYXRwb2NzL3YxO2NhdHBvY3N2MWIGcHJvdG8z");

/**
 * User represents a platform user
 *
 * @generated from message catpocs.v1.User
 */
export type User = Message<"catpocs.v1.User"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string email = 2;
   */
  email: string;

  /**
   * @generated from field: string name = 3;
   */
  name: string;

  /**
   * @generated from field: repeated string groups = 4;
   */
  groups: string[];

  /**
   * @generated from field: bool is_super_admin = 5;
   */
  isSuperAdmin: boolean;
};

/**
 * Describes the message catpocs.v1.User.
 * Use `create(UserSchema)` to create a new message.
 */
export const UserSchema: GenMessage<User> = /*@__PURE__*/
  messageDesc(file_catpocs_v1_roles, 0);

/**
 * Permission represents a permission on a resource
 *
 * @generated from message catpocs.v1.Permission
 */
export type Permission = Message<"catpocs.v1.Permission"> & {
  /**
   * @generated from field: string resource = 1;
   */
  resource: string;

  /**
   * @generated from field: repeated string actions = 2;
   */
  actions: string[];
};

/**
 * Describes the message catpocs.v1.Permission.
 * Use `create(PermissionSchema)` to create a new message.
 */
export const PermissionSchema: GenMessage<Permission> = /*@__PURE__*/
  messageDesc(file_catpocs_v1_roles, 1);

/**
 * GetCurrentUserRequest is the request message for GetCurrentUser
 *
 * @generated from message catpocs.v1.GetCurrentUserRequest
 */
export type GetCurrentUserRequest = Message<"catpocs.v1.GetCurrentUserRequest"> & {
};

/**
 * Describes the message catpocs.v1.GetCurrentUserRequest.
 * Use `create(GetCurrentUserRequestSchema)` to create a new message.
 */
export const GetCurrentUserRequestSchema: GenMessage<GetCurrentUserRequest> = /*@__PURE__*/
  messageDesc(file_catpocs_v1_roles, 2);

/**
 * GetCurrentUserResponse is the response message for GetCurrentUser
 *
 * @generated from message catpocs.v1.GetCurrentUserResponse
 */
export type GetCurrentUserResponse = Message<"catpocs.v1.GetCurrentUserResponse"> & {
  /**
   * @generated from field: catpocs.v1.User user = 1;
   */
  user?: User;

  /**
   * @generated from field: repeated catpocs.v1.Permission global_permissions = 2;
   */
  globalPermissions: Permission[];

  /**
   * Impersonation info
   *
   * @generated from field: bool is_impersonating = 3;
   */
  isImpersonating: boolean;

  /**
   * The real user if impersonating
   *
   * @generated from field: catpocs.v1.User original_user = 4;
   */
  originalUser?: User;

  /**
   * The user being impersonated
   *
   * @generated from field: catpocs.v1.User impersonated_user = 5;
   */
  impersonatedUser?: User;
};

/**
 * Describes the message catpocs.v1.GetCurrentUserResponse.
 * Use `create(GetCurrentUserResponseSchema)` to create a new message.
 */
export const GetCurrentUserResponseSchema: GenMessage<GetCurrentUserResponse> = /*@__PURE__*/
  messageDesc(file_catpocs_v1_roles, 3);

/**
 * GetUserPermissionsRequest is the request message for GetUserPermissions
 *
 * @generated from message catpocs.v1.GetUserPermissionsRequest
 */
export type GetUserPermissionsRequest = Message<"catpocs.v1.GetUserPermissionsRequest"> & {
  /**
   * @generated from field: string project_id = 1;
   */
  projectId: string;
};

/**
 * Describes the message catpocs.v1.GetUserPermissionsRequest.
 * Use `create(GetUserPermissionsRequestSchema)` to create a new message.
 */
export const GetUserPermissionsRequestSchema: GenMessage<GetUserPermissionsRequest> = /*@__PURE__*/
  messageDesc(file_catpocs_v1_roles, 4);

/**
 * GetUserPermissionsResponse is the response message for GetUserPermissions
 *
 * @generated from message catpocs.v1.GetUserPermissionsResponse
 */
export type GetUserPermissionsResponse = Message<"catpocs.v1.GetUserPermissionsResponse"> & {
  /**
   * @generated from field: string role = 1;
   */
  role: string;

  /**
   * @generated from field: repeated catpocs.v1.Permission permissions = 2;
   */
  permissions: Permission[];
};

/**
 * Describes the message catpocs.v1.GetUserPermissionsResponse.
 * Use `create(GetUserPermissionsResponseSchema)` to create a new message.
 */
export const GetUserPermissionsResponseSchema: GenMessage<GetUserPermissionsResponse> = /*@__PURE__*/
  messageDesc(file_catpocs_v1_roles, 5);

/**
 * ListSuperAdminsRequest is the request message for ListSuperAdmins
 *
 * @generated from message catpocs.v1.ListSuperAdminsRequest
 */
export type ListSuperAdminsRequest = Message<"catpocs.v1.ListSuperAdminsRequest"> & {
};

/**
 * Describes the message catpocs.v1.ListSuperAdminsRequest.
 * Use `create(ListSuperAdminsRequestSchema)` to create a new message.
 */
export const ListSuperAdminsRequestSchema: GenMessage<ListSuperAdminsRequest> = /*@__PURE__*/
  messageDesc(file_catpocs_v1_roles, 6);

/**
 * ListSuperAdminsResponse is the response message for ListSuperAdmins
 *
 * @generated from message catpocs.v1.ListSuperAdminsResponse
 */
export type ListSuperAdminsResponse = Message<"catpocs.v1.ListSuperAdminsResponse"> & {
  /**
   * @generated from field: repeated catpocs.v1.User admins = 1;
   */
  admins: User[];
};

/**
 * Describes the message catpocs.v1.ListSuperAdminsResponse.
 * Use `create(ListSuperAdminsResponseSchema)` to create a new message.
 */
export const ListSuperAdminsResponseSchema: GenMessage<ListSuperAdminsResponse> = /*@__PURE__*/
  messageDesc(file_catpocs_v1_roles, 7);

/**
 * AddSuperAdminRequest is the request message for AddSuperAdmin
 *
 * @generated from message catpocs.v1.AddSuperAdminRequest
 */
export type AddSuperAdminRequest = Message<"catpocs.v1.AddSuperAdminRequest"> & {
  /**
   * @generated from field: string user_id = 1;
   */
  userId: string;

  /**
   * @generated from field: string email = 2;
   */
  email: string;
};

/**
 * Describes the message catpocs.v1.AddSuperAdminRequest.
 * Use `create(AddSuperAdminRequestSchema)` to create a new message.
 */
export const AddSuperAdminRequestSchema: GenMessage<AddSuperAdminRequest> = /*@__PURE__*/
  messageDesc(file_catpocs_v1_roles, 8);

/**
 * AddSuperAdminResponse is the response message for AddSuperAdmin
 *
 * @generated from message catpocs.v1.AddSuperAdminResponse
 */
export type AddSuperAdminResponse = Message<"catpocs.v1.AddSuperAdminResponse"> & {
  /**
   * @generated from field: catpocs.v1.User admin = 1;
   */
  admin?: User;
};

/**
 * Describes the message catpocs.v1.AddSuperAdminResponse.
 * Use `create(AddSuperAdminResponseSchema)` to create a new message.
 */
export const AddSuperAdminResponseSchema: GenMessage<AddSuperAdminResponse> = /*@__PURE__*/
  messageDesc(file_catpocs_v1_roles, 9);

/**
 * RemoveSuperAdminRequest is the request message for RemoveSuperAdmin
 *
 * @generated from message catpocs.v1.RemoveSuperAdminRequest
 */
export type RemoveSuperAdminRequest = Message<"catpocs.v1.RemoveSuperAdminRequest"> & {
  /**
   * @generated from field: string user_id = 1;
   */
  userId: string;
};

/**
 * Describes the message catpocs.v1.RemoveSuperAdminRequest.
 * Use `create(RemoveSuperAdminRequestSchema)` to create a new message.
 */
export const RemoveSuperAdminRequestSchema: GenMessage<RemoveSuperAdminRequest> = /*@__PURE__*/
  messageDesc(file_catpocs_v1_roles, 10);

/**
 * RemoveSuperAdminResponse is the response message for RemoveSuperAdmin
 *
 * @generated from message catpocs.v1.RemoveSuperAdminResponse
 */
export type RemoveSuperAdminResponse = Message<"catpocs.v1.RemoveSuperAdminResponse"> & {
  /**
   * @generated from field: bool success = 1;
   */
  success: boolean;
};

/**
 * Describes the message catpocs.v1.RemoveSuperAdminResponse.
 * Use `create(RemoveSuperAdminResponseSchema)` to create a new message.
 */
export const RemoveSuperAdminResponseSchema: GenMessage<RemoveSuperAdminResponse> = /*@__PURE__*/
  messageDesc(file_catpocs_v1_roles, 11);

/**
 * RoleService manages user roles and permissions
 *
 * @generated from service catpocs.v1.RoleService
 */
export const RoleService: GenService<{
  /**
   * GetCurrentUser retrieves the current user's information
   *
   * @generated from rpc catpocs.v1.RoleService.GetCurrentUser
   */
  getCurrentUser: {
    methodKind: "unary";
    input: typeof GetCurrentUserRequestSchema;
    output: typeof GetCurrentUserResponseSchema;
  },
  /**
   * GetUserPermissions retrieves permissions for a user in a project
   *
   * @generated from rpc catpocs.v1.RoleService.GetUserPermissions
   */
  getUserPermissions: {
    methodKind: "unary";
    input: typeof GetUserPermissionsRequestSchema;
    output: typeof GetUserPermissionsResponseSchema;
  },
  /**
   * ListSuperAdmins lists all super admins
   *
   * @generated from rpc catpocs.v1.RoleService.ListSuperAdmins
   */
  listSuperAdmins: {
    methodKind: "unary";
    input: typeof ListSuperAdminsRequestSchema;
    output: typeof ListSuperAdminsResponseSchema;
  },
  /**
   * AddSuperAdmin adds a super admin (super admin only)
   *
   * @generated from rpc catpocs.v1.RoleService.AddSuperAdmin
   */
  addSuperAdmin: {
    methodKind: "unary";
    input: typeof AddSuperAdminRequestSchema;
    output: typeof AddSuperAdminResponseSchema;
  },
  /**
   * RemoveSuperAdmin removes a super admin (super admin only)
   *
   * @generated from rpc catpocs.v1.RoleService.RemoveSuperAdmin
   */
  removeSuperAdmin: {
    methodKind: "unary";
    input: typeof RemoveSuperAdminRequestSchema;
    output: typeof RemoveSuperAdminResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_catpocs_v1_roles, 0);

